import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class UserStatistic extends Component {
  static propTypes = {
    statistic: PropTypes.object.isRequired,
  };

  render() {
    const {
      visitsCount,
      commentsCount,
      downloadedTrainingMaterialsCount,
      forumTopicCount,
      leftLikesCount,
      practiceCasesCount,
      setLikesCount
    } = this.props.statistic;
    return (
      <div className="user-profile__block user-profile__statistic">
        <h2 className="page-subtitle">Статистика:</h2>

        <div className="statistic__item">
          <div className="statistic__description">Всего посещений:</div>
          <div className="statistic__value">{visitsCount}</div>
        </div>
        <div className="statistic__item">
          <div className="statistic__description">
            Скачано материалов «Обучение»:
          </div>
          <div className="statistic__value">{downloadedTrainingMaterialsCount}</div>
        </div>
        <div className="statistic__item">
          <div className="statistic__description">
            Выложено материалов «Практика»:
          </div>
          <div className="statistic__value">{practiceCasesCount}</div>
        </div>
        <div className="statistic__item">
          <div className="statistic__description">
            Поставлено лайков/осталось:
          </div>
          <div className="statistic__value">{`${setLikesCount}/${leftLikesCount}`}</div>
        </div>
        <div className="statistic__item">
          <div className="statistic__description">Сообщений в форуме:</div>
          <div className="statistic__value">{commentsCount}</div>
        </div>
        <div className="statistic__item">
          <div className="statistic__description">Тем в форуме:</div>
          <div className="statistic__value">{forumTopicCount}</div>
        </div>
      </div>
    );
  }
}
